import SimpleTablePage from "../common/SimpleTablePage";

const columns = [
  { title: "ID", dataIndex: "id", key: "id", width: 100 },
  { title: "Nome", dataIndex: "name", key: "name", ellipsis: true },
];

export default function Mansions() {
  return (
    <SimpleTablePage resource="mansion" title="Mansioni" columns={columns} searchQueryName="name" />
  );
}
